import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { routes } from 'router';
import { Toaster } from 'components/ui/toaster';
import ProtectedRoute from 'components/protected-route'; // Import ProtectedRoute

function App() {
    return (
        <Router>
            <Routes>
                {/* Dynamically generate routes from the routes object */}
                {Object.values(routes).map((route) => (
                    <Route
                        key={route.name}
                        path={route.path}
                        element={
                            route.isProtected ? (
                                <ProtectedRoute>
                                    {route.element}
                                </ProtectedRoute>
                            ) : (
                                route.element
                            )
                        }
                    />
                ))}
            </Routes>
            <Toaster/>
        </Router>
    );
}

export default App;
